/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AlignMiddleIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Align Middle',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M35.5 16H30V9a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v7h-4V5a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v11H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H6v11a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V18h4v7a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-7h5.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z"
    />
  </svg>`;
};
